(() => {
  if (window.cartDrawerAddonsInitialized) return;
  window.cartDrawerAddonsInitialized = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-drawer-addon-add]');
    if (!button || button.classList.contains('is-loading')) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const label = button.querySelector('[data-cart-drawer-addon-label]');
    button.classList.add('is-loading');
    button.disabled = true;
    if (label) label.textContent = 'Adding...';

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });

      const parsedState = await response.json();
      if (!response.ok) throw parsedState;

      const drawer = document.querySelector('cart-drawer');
      if (!drawer || !parsedState.sections?.['cart-drawer']) throw new Error('Cart drawer unavailable');
      drawer.renderContents(parsedState);
    } catch (error) {
      button.classList.remove('is-loading');
      button.disabled = false;
      if (label) label.textContent = 'Try again';
      console.error('Cart drawer add-on failed:', error);
    }
  });
})();
